
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './redux/reducers'

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware(), // thunk ya viene incluido
    devTools: true, // las devtools se activan automáticamente
});

export default store;